import { iconProps } from '../types/icon';

const IconEmail = ({ size="32", fill="currentColor"}: iconProps) => (
  <svg width={size} height={size} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <polygon fill={fill} points="16 14.87 25.07 9.19 6.93 9.19 16 14.87"/>
    <polygon fill={fill} points="6.93 11.46 6.93 22.81 25.07 22.81 25.07 11.46 16 17.13 6.93 11.46"/>
    <path fill={fill} d="M29.63,0H2.36C1.06,0,0,1.03,0,2.31v27.39c0,1.28,1.06,2.31,2.36,2.31h27.27c1.3,0,2.37-1.03,2.37-2.31V2.31C32,1.03,30.93,0,29.63,0ZM27.34,22.81c0,.62-.22,1.16-.67,1.6s-.98.67-1.6.67H6.93c-.62,0-1.16-.22-1.6-.67s-.67-.98-.67-1.6v-13.61c0-.62.22-1.16.67-1.6s.98-.67,1.6-.67h18.15c.62,0,1.16.22,1.6.67s.67.98.67,1.6v13.61Z"/>
  </svg>
);

export default IconEmail;
